import React, { Component } from 'react';
import { Box, Fab, Typography } from '@material-ui/core';
import { CloudDownloadRounded } from '@material-ui/icons';
// import { CloudDownloadRounded } from '@mui/icons-material';

class TitleWithEndAction extends Component {
    state = {  }
    render() {
        const { title, action, actionColor, actionTitle, disabled, children} = this.props;
        return (
            <Box p={1} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Typography variant="h6" id="tableTitle">
                    {title}
                </Typography>

                <Box >
                    {children}
                    <span> </span>
                    {action &&
                        <Fab 
                            color={actionColor || "primary"} 
                            onClick={action} 
                            title={actionTitle || "Télécharger"} 
                            disabled={disabled}
                            size="small"
                        >
                            <CloudDownloadRounded />
                        </Fab>
                        // <IconButton 
                        //     color={actionColor || "primary"} 
                        //     // onClick={() => this.props.openFormDownload("/extract/payments")} 
                        //     onClick={action} 
                        //     title={actionTitle || "Télécharger"} 
                        //     disabled={disabled}
                        // >
                        //     <CloudDownloadRounded />
                        // </IconButton>
                    
                    }
                </Box>
            </Box> 
        );
    }
}

export default TitleWithEndAction;